<template>
  <div class="content container-fluid">
    <!-- Begin: Popover for Filter -->
    <popover
      name="popEmailTo"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmailTo"
        :options="colFilter.tranEmailToColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popEmailCc"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmailCc"
        :options="colFilter.tranEmailCcColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Begin: Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Email Logs</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div class="row align-items-center">
      <div class="col-md-2 title-left">Subject</div>
      <div class="col-md-4 pl-md-0">
        <input type="text" class="form-control" v-model="subject" />
      </div>

      <div class="col-md-1 title-right ml-5">Email</div>
      <div class="col-md-4 pl-md-0">
        <input type="text" class="form-control" v-model="email" />
      </div>
    </div>

    <div class="row align-items-center mt-2">
      <div class="col-md-2 title-left">Date From</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <input type="date" class="form-control" v-model="dateFrom" />
      </div>
      <div class="col-md-1 fit-content">Date To</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <input
          type="date"
          class="form-control"
          v-model="dateTo"
          :min="dateFrom"
        />
      </div>

      <div class="col-md-1 title-right" style="margin-left: 26px">Status</div>
      <div class="col-md-2 pl-md-0 fit-content">
        <select class="custom-select" v-model="status">
          <option value>All</option>
          <option value="Success">Success</option>
          <option value="Fail">Fail</option>
        </select>
      </div>

      <div class="col-md-2">
        <button class="btn btn-primary" @click="getLogs">Search</button>
      </div>
    </div>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-2">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="date-column">
                  <button class="btn p-0" @click="setSortBy('sentDate')">
                    Sent Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'sentDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'sentDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th class="subject-column">
                  <button class="btn p-0" @click="setSortBy('subject')">
                    Subject
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'subject'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'subject_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th class="to-column">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmailTo
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmailTo.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('to')">
                    Email To
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'to'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'to_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="cc-column">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmailCc
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmailCc.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('cc')">
                    Email Cc
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'cc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'cc_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-column">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="error-column">
                  <button class="btn p-0" @click="setSortBy('error')">
                    Error Message
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'error'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'error_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in logs" :key="item.Id">
                <td class="date-column">{{ item.SentDateDisplay }}</td>
                <td class="subject-column">{{ item.Subject }}</td>
                <td class="to-column">{{ item.SentTo }}</td>
                <td class="cc-column">{{ item.SentCc }}</td>
                <td
                  :class="
                    item.Status == 'Success'
                      ? 'status-column green'
                      : 'status-column red'
                  "
                >
                  {{ item.Status }}
                </td>
                <td class="error-column">{{ item.ErrorMessage }}</td>
              </tr>

              <tr v-if="logs && !logs.length">
                <td colspan="6" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="logs && logs.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          logs.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      logs: [],
      subject: "",
      email: "",
      dateFrom: "",
      dateTo: "",
      status: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      searchColFilter: {
        tranEmailTo: [],
        tranEmailCc: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    searchFilter() {
      return [
        { name: "tranEmailTo", val: this.searchColFilter.tranEmailTo },
        { name: "tranEmailCc", val: this.searchColFilter.tranEmailCc },
      ];
    },
  },
  watch: {
    "searchColFilter.tranEmailTo": function (val, oldVal) {
      this.getLogs();
    },
    "searchColFilter.tranEmailCc": function (val, oldVal) {
      this.getLogs();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    getLogs() {
      let param = {
        Token: this.token,
        Subject: this.subject,
        Email: this.email,
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
        Status: this.status,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getEmailLogs(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.logs = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getLogs();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getLogs();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getLogs();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getLogs();
    },
    setSortBy(payload) {
      switch (payload) {
        case "sentDate":
          if (this.paging.SortBy === "sentDate") {
            this.paging.SortBy = "sentDate_desc";
          } else if (this.paging.SortBy === "sentDate_desc") {
            this.paging.SortBy = "sentDate";
          } else {
            this.paging.SortBy = "sentDate";
          }
          break;
        case "subject":
          if (this.paging.SortBy === "subject") {
            this.paging.SortBy = "subject_desc";
          } else if (this.paging.SortBy === "subject_desc") {
            this.paging.SortBy = "subject";
          } else {
            this.paging.SortBy = "subject";
          }
          break;
        case "to":
          if (this.paging.SortBy === "to") {
            this.paging.SortBy = "to_desc";
          } else if (this.paging.SortBy === "to_desc") {
            this.paging.SortBy = "to";
          } else {
            this.paging.SortBy = "to";
          }
          break;
        case "cc":
          if (this.paging.SortBy === "cc") {
            this.paging.SortBy = "cc_desc";
          } else if (this.paging.SortBy === "cc_desc") {
            this.paging.SortBy = "cc";
          } else {
            this.paging.SortBy = "cc";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
        case "error":
          if (this.paging.SortBy === "error") {
            this.paging.SortBy = "error_desc";
          } else if (this.paging.SortBy === "error_desc") {
            this.paging.SortBy = "error";
          } else {
            this.paging.SortBy = "error";
          }
          break;
      }
      this.getLogs();
    },
  },
  created() {
    if (this.role == "admin") this.getLogs();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}

.title-left {
  max-width: 110px;
}

.title-right {
  max-width: 70px;
}

.red {
  color: red;
}

.green {
  color: green;
}

.table-responsive {
  white-space: unset;
}

.table {
  width: 2000px;
}

.date-column {
  width: 11%;
}
.subject-column {
  width: 25%;
}
.to-column,
.cc-column {
  width: 15%;
}
.status-column {
  width: 7%;
}
</style>


// WEBPACK FOOTER //
// src/components/System/EmailLog.vue